export const formModule = {

    state() {
        return {
            resultCallBack: false,
            resultMessage: false,
        }
    },

    getters: {
        resultCallBack(state) {
            return state.resultCallBack
        },
        resultMessage(state) {
            return state.resultMessage
        }
    },

    mutations: {
        setResultCallBack(state, data) {
            state.resultCallBack = data
        },
        setResultMessage(state, data) {
            state.resultMessage = data
        },
    },

    actions: {
        async sendCallBack({ commit }, data) {
            // const dataResponse = {
            //     name: data.name,
            //     telephone: data.telephone,
            // };
            await axios.post('/api/call-back', data).then((res) => {
                commit('setResultCallBack', true);
            }).catch((err) => {

            })
        },
        async sendMessage({ commit }, data) {
            await axios.post('/api/message', data).then((res) => {
                commit('setResultMessage', true);
            }).catch((err) => {

            })
        },
    },

    namespaced: true,
};